import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ADMIN_FONT_ROUTES, FILES_FONT_ROUTES } from '@lite-workspace/route-contract';

import { FontApiResponse } from '../entities/font.types';
import { AdminFontsDataPort } from './admin-fonts.data';

@Injectable({ providedIn: 'root' })
export class HttpAdminFontsData implements AdminFontsDataPort {
  private readonly http = inject(HttpClient);

  loadFonts(): Promise<FontApiResponse[]> {
    return firstValueFrom(this.http.get<FontApiResponse[]>(ADMIN_FONT_ROUTES.api.fonts));
  }

  async setFontPublic(id: string, isPublic: boolean): Promise<void> {
    await firstValueFrom(this.http.patch(FILES_FONT_ROUTES.api.byId(id), { isPublic }));
  }
}
